import React, { useEffect, useState } from "react";
import { ISuburbSelection, update } from "../../../models/suburbSelection";
import { Input } from "reactstrap";

interface TargetRationaleControlProps {
  suburbSelection: ISuburbSelection;
}

export const TargetRationaleControl = (props: TargetRationaleControlProps) => {
  const [suburbSelection, setSuburbSelection] = useState<ISuburbSelection>(props.suburbSelection);
  const [triggerUpdate, setTriggerUpdate] = useState<boolean>(false);
  useEffect(() => {
    if (triggerUpdate && suburbSelection.targetRationale !== props.suburbSelection.targetRationale) {
      update(suburbSelection).then(() => setTriggerUpdate(false));
    }
  }, [triggerUpdate]);

  return (
    <Input
      title={suburbSelection.targetRationale}
      type="textarea"
      value={suburbSelection.targetRationale}
      onChange={(e) => {
        e.persist();
        setSuburbSelection((x) => ({ ...x, targetRationale: e.target.value }));
      }}
      onBlur={() => setTriggerUpdate(true)}
    ></Input>
  );
};
